<template>
    <form @submit.prevent="submitHandler" class="lg:flex">
        <div class="tra__message-form relative lg:w-2/3 lg:pr-3">
          <div class="grid grid-cols-6 gap-6">
              <div class="col-span-12 lg:col-span-3 mb-3">
                <label for="form-name" class="block text-base font-semibold text-gray-700">Template Name
                  <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.templateName" name="form-name" id="form-name" autocomplete="off" required
                  class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md" />
                  <p v-if="form.errors.templateName" class="text-red-500 text-sm mt-1">
                      {{ form.errors.templateName }}
                    </p>
              </div>
          </div>
          <div v-if="$page.props.is_admin" class="mb-3">
            <label class="flex items-center">
              <input type="checkbox" v-model="form.shared" class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
              <span class="ml-2 text-sm text-gray-700">Shared template (visible to all users in organization)</span>
            </label>
          </div>
            <div class="w-full mt-4 mb-4">
                <MessageFormEditor
                    v-model="editorFields"
                    :error="errors.unparsed_message ? errors.unparsed_message : null"
                    @image-preview="data => imagePreview = data"
                />
                <p v-if="form.errors.unparsed_message" class="text-red-500 text-sm mt-1">
                  {{ form.errors.unparsed_message }}
                </p>
            </div>
            <div class="flex justify-between p-2 md:p-8 items-center bg-gray-100 rounded-lg">
                <div>
                    <template v-if="creditCount > 0">
                        Your template will use <span class='font-bold text-gray-700'>{{ creditCount }} {{ creditCount == 1 ? 'credit' : 'credits' }}</span> per message.
                    </template>
                    <template v-else>
                        Type a message to get started!
                    </template>
                </div>

                <div class="">
                  <Link class="mr-4" :href="route('template.index')">
                      Cancel
                  </Link>

                    <jet-button
                        :loading="loading"
                    >
                        {{ sendButtonText }}
                    </jet-button>
                </div>
            </div>
        </div>
        <div class="lg:border-t-0 border-t border-t-1 border-t-gray-200 lg:w-1/3 lg:pl-3 pt-6 lg:pt-0 mt-6 lg:mt-0 flex">
            <MessageFormPreview
                :message="editorFields.message"
                :media="imagePreview"
            />
        </div>

    </form>
</template>

<script>
import MessageHeldForReviewModal from './Modals/MessageHeldForReview';
import JetDialogModal from '../Jetstream/DialogModal';

import JetButton from "../Jetstream/Button";
import axios from "axios";

import JetSecondaryButton from '../Jetstream/SecondaryButton';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faImage } from "@fortawesome/pro-regular-svg-icons";
library.add(faImage);
import ContactSelect from './ContactSelect';
import MessageFormEditor from './TemplateForm/MessageFormEditor.vue';
import MessageFormPreview from './TemplateForm/MessageFormPreview.vue';
import ButtonSelect from './ButtonSelect';

import { SegmentedMessage } from 'sms-segments-calculator';


export default {
    emits: ['success'],
    components: {
        //DatePicker,
        JetButton,
        JetDialogModal,
        JetSecondaryButton,
        ContactSelect,
        MessageFormEditor,
        MessageFormPreview,
        ButtonSelect,
        MessageHeldForReviewModal,
    },
    props: {
      template:  Object
    },
    mounted() {
        if (this.template) {
          this.form.templateName = this.template.name;
          this.form.shared = this.template.shared || false;
          this.editorFields.message = this.template.message;
          this.editorFields.media = this.template.media;
          this.imagePreview = this.template.media
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                templateId: null,
                templateName: null,
                unparsed_message: null,
                media: null,
                shared: false,
            }, {
                resetOnSuccess: true,
            }),
            uploadImageFormVisible: false,
            phone_number: null,
            current_date: "",
            errors: {
                unparsed_message: null,
            },
            segment_lengths: {
                sms_ucs: 70,
                sms_gsm: 160,
                mms_ucs: 1000,
                mms_gsm: 1600
            },
            sms_segment_credit: 1,
            mms_segment_credit: 3,
            messageHeldForReviewIsOpen: false,
            creditOverageModal: false,
            imagePreview: null,
            creditLimitData: null,
            editorFields: {
                message: "",
                media: null
            },
        };
    },
  computed: {
        loading () {
            return this.form.processing;
        },
        sendButtonText() {
            if (this.loading) {
                return "Processing...";
            }
            return "SAVE";
        },
        messageSegments() {
            return new SegmentedMessage(this.editorFields.message);
        },
        characterCount() {
            return this.editorFields.message.length;
        },
        /*
        Estimated number of credits to be used by the message
         */
        creditCount() {
            if (this.editorFields.media && !_.isEmpty(this.editorFields.media)) {
                // divide character count by segment length and round up
                // to nearest integer to get number of segments, and then
                // we multiply that by the number of credits per segment to
                // get total estimated credit cost
                if ( this.messageSegments.encodingName === 'GSM-7' && this.characterCount ) {
                    return Math.ceil(this.characterCount / this.segment_lengths.mms_gsm) * this.mms_segment_credit * 1;
                }

                if ( this.messageSegments.encodingName === 'UCS-2' && this.characterCount ) {
                    return Math.ceil(this.characterCount / this.segment_lengths.mms_ucs) * this.mms_segment_credit * 1;
                }

                if ( !this.characterCount) {
                  return this.mms_segment_credit;
                }
            } else {
                return this.messageSegments.segmentsCount;
            }
        },
    },
    methods: {
        successMessage() {
            const type = this.template ? 'updated' : 'created';
            this.$toasted.show(`Your template has been successfully ${type}!`, {
                position: "bottom-right",
                type: "success",
                duration: 3000
            });
        },
        errorMessage(error) {
            this.errors = error;
            let errorMessage = "Uh oh! Something went wrong.";

            if (error.message == 'held_for_review' ) {
                this.messageHeldForReviewIsOpen = true;
                return;
            }

            if ( error.message ) {
              errorMessage = error.display_message;
            }

            this.$toasted.show(errorMessage, {
                position: "bottom-right",
                type: "error",
                duration: 3000
            });
        },
        resetValues() {
            this.editorFields.message = "";
            this.form.unparsed_message = null;
            this.errors = {};
        },
        async submitHandler() {
            this.form.transform((data) => ({
              ...data,
              templateId : this.template ? this.template.id : null
            }))
            .post(route("template.store"), {
                onSuccess: () => {
                    this.successMessage();
                    this.$emit('success');
                },
                onError: error => {
                    console.log(error)
                    this.errorMessage(error);
                }
            });
        }
    },
    watch: {
        editorFields: {
            handler(value) {
                this.form.unparsed_message = value.message;
                this.form.media = value.media;
            },
            deep: true
        },
    }
};
</script>

<style>
.toasted.success {
    @apply bg-green-500 text-white font-bold shadow rounded !important;
}

.toasted.error {
    @apply bg-red-500 text-white font-bold shadow rounded !important;
}

.mx-datepicker {
    width: 100% !important;
}

.mx-input {
    @apply border-2 border-gray-300;
    height: 40px;
}

.input-tel__input,
.country-selector__input {
    @apply border-2 border-gray-300 !important;
}

.input-tel__input {
    @apply border-l-0 !important;
}

select {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%2371717a' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 2.5rem;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.occurrences input {
    @apply w-1/3;

    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.vs__dropdown-toggle {
    height: 42px;
}

.triangle {
    position: absolute;
    bottom: -33px;
    height: 25px;
    width: 40px;
    background: #ebf8ff;
    z-index: 1;
    display: block;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    pointer-events: none;
}

</style>
